import React, { useEffect, useRef } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';

const HeaderCarousel = () => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const initCarousel = () => {
      if (window.$ && window.$.fn && window.$.fn.owlCarousel && carouselRef.current) {
        const $carousel = window.$(carouselRef.current);

        if ($carousel.data('owl.carousel')) {
          $carousel.trigger('destroy.owl.carousel');
        }

        $carousel.owlCarousel({
          autoplay: true,
          smartSpeed: 1500,
          loop: true,
          nav: true,
          dots: false,
          items: 1,
          navText: [
            '<i class="bi bi-chevron-left"></i>',
            '<i class="bi bi-chevron-right"></i>'
          ]
        });

        return () => {
          if ($carousel.data('owl.carousel')) {
            $carousel.trigger('destroy.owl.carousel');
          }
        };
      } else {
        setTimeout(initCarousel, 100);
      }
    };

    const cleanup = initCarousel();
    return cleanup;
  }, []);

  const carouselItems = [
    {
    image: '/img/img24.jpg',
    subtitle: '// Design & Build Solutions',
    title: 'From Concept to Complete Execution',
    description:
      'We deliver end-to-end design and build solutions, managing everything from planning and interiors to final execution with precision.'
  },
  {
    image: '/img/img241.jpg',
    subtitle: '// Interior Fit-Out & Installations',
    title: 'Crafting Functional, Elegant Spaces',
    description:
      'Expert interior fit-outs, custom installations, and detailing that bring beauty, comfort, and functionality together.'
  },
    {
      image: '/img/img21.jpg',
      subtitle: '// Creative & Modern Interiors',
      title: 'Where Style Meets Comfort',
      description: 'From concept to completion, we transform spaces into timeless, beautiful environments.'
    }
  ];


  return (
    <Fade triggerOnce>
      <div className="container-fluid p-0 pb-5">
        <div className="owl-carousel header-carousel position-relative" ref={carouselRef}>
        {carouselItems.map((item, index) => (
          <div key={index} className="owl-carousel-item position-relative">
            <img className="img-fluid" src={item.image} alt={`Carousel ${index + 1}`} />
            <div className="owl-carousel-inner">
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-lg-8">
                    <p className="text  text-uppercase fw-bold mb-2">{item.subtitle}</p>
                    <h1 className="display-1 text-light mb-4 animated slideInDown">{item.title}</h1>
                    <p className="text-light fs-5 mb-4 pb-3">{item.description}</p>
                    <Link
                      to="/contact"
                      className="btn btn-primarys rounded-pill py-3 px-5"
                    >
                      Contact Us
                    </Link>

                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        </div>
      </div>
    </Fade>
  );
};

export default HeaderCarousel;






